module.exports = __webpack_public_path__ + "img/RYO_ROUND_S.af39fb66.png";